import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";

import { useUiStore } from "@/lib/uiStore";

import type { NavSection } from "./navSections";
import { ServiceNav } from "./ServiceNav";

/**
 * 第一層某一節底下的第二層選單。
 *
 * 只有 `hasPanel` 為真的分節才會被渲染 —— 目前是「服務」。之後若「個人中心」
 * 長出子頁（基本資料／安全性／通知偏好），在這裡加一個 case 就好，rail 與
 * 手機底部列都不用改。
 *
 * 面板的標題就是分節的名稱，不是寫死的「平台」：使用者切到不同分節時，
 * 這裡要能回答「我現在展開的是哪一節」。
 */
export function SectionPanel({ section }: { section: NavSection }) {
  const setRailExpanded = useUiStore((state) => state.setRailExpanded);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1.75 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pl: 1.5 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 700 }}>
          {section.label}
        </Typography>
        <Tooltip title="收合">
          <IconButton size="small" onClick={() => setRailExpanded(false)} aria-label="收合第二層選單">
            <KeyboardDoubleArrowLeftOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ mt: 1.75, overflowY: "auto", minHeight: 0 }}>
        {section.key === "services" && <ServiceNav />}
      </Box>
    </Box>
  );
}
